import apiClient from "./client";

export const getAllCategories = async (language: string) => {
    const response = await apiClient.get('/category/get-all-categories', {
        headers: {
            'Accept-Language': language || 'en'
        }
    });
    console.log(response.data);
    return response.data;
}